<template>
  <div
      :class="{
        'cur-pointer': !isUnreachableMatch,
      }"
      class="PRO-LIST-ITEM"
      selenium="matched-pro-item">
    <div
        :class="{
          'FADE': isUnreachableMatch,
        }"
        class="AVATAR-WRAPPER d-flex flex-center">
      <pro-avatar
          :image="pro.service_provider.logo"
          :size="64"/>
    </div>
    <div
        :class="{
          'FADE': !isActiveMatch || isUnreachableMatch,
        }"
        class="PRO-INFO">
      <div class="text-bold" selenium="pro-list-item-business-name">
        {{ pro.service_provider.business_name }}
      </div>
      <div v-if="pro.service_provider.addresses && pro.service_provider.addresses.length > 0" class="d-flex ai-center text-md">
        <vk-icon name="pin" class="c-depot m-r-1" size="16"/>
        {{ pro.service_provider.addresses[0].city }}, {{ pro.service_provider.addresses[0].state }}
      </div>
    </div>
    <div v-if="isActiveMatch || isUnreachableMatch" class="BADGES">
      <div
          :class="{ 'bd-green c-green': isActiveMatch, 'bd-gray40 c-gray40': isUnreachableMatch }"
          class="BADGE"
          selenium="pro-list-item-status-badge">
        {{ badgeText }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'pro-list-item',
  components: {},
  props: {
    match: {
      type: Object,
      required: true,
    },
    pro: {
      type: Object,
      required: true,
    },
    isUnreachableMatch: {
      type: Boolean,
      required: true,
    },
    isActiveMatch: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    badgeText () {
      if (this.isUnreachableMatch) {
        return 'not available';
      }
      if (this.isActiveMatch) {
        return 'active';
      }

      return this.match.match_status;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .PRO-LIST-ITEM {
    @include padding(2 3 2 4);

    display: grid;
    grid-gap: $unit*2;

    grid-template: "avatar-wrapper pro-info" 1fr
                   "avatar-wrapper badges"/
                    auto           1fr ;

    @include tablet {
      grid-template: "avatar-wrapper pro-info badges" 1fr /
                      auto           1fr      minmax(0px, 130px); //; //0px for IE
    }
  }

  .AVATAR-WRAPPER {
    grid-area: avatar-wrapper;
  }

  .PRO-INFO {
    grid-area: pro-info;
  }

  .BADGES {
    grid-area: badges;
    display: flex;
    align-items: center;

    @include tablet {
      justify-content: flex-end;
    }
  }

  .BADGE {
    @include text-small;
    @include padding(0.25 2);
    display: flex;
    justify-content: center;
    text-transform: uppercase;
    border-radius: 12px;

    @include tablet {
      width: 100;
    }
  }

  .FADE {
    opacity: 0.5;
  }
</style>
